import React from 'react'

function DEScription() {
  return (
    <div>
      <h3>Product Description</h3>
      <p>
        Since it's creation lorem ipsum dolor sit amet consectetur adipisicing elit. Omnis, at.
        Nesciunt voluptatem magni maiores eum, delectus architecto itaque
        eligendi, libero deleniti hic iure praesentium ad sit laudantium qui
        quod? Corrupti dolorem a sunt iure nulla est debitis sit placeat
        <br />
        <br />
        excepturi commodi, similique dolorum rem laboriosam adipisci repudiandae
        laudantium voluptatem sint.
      </p>
    </div>
  );
}

export default DEScription